import {Injectable} from '@angular/core';
import {DocumentCategory} from "../../domain/documentCategory";
import {GenericService} from "../../../core/commons/generic.service";
import {AuthService} from "../../../core/security/auth.service";
import {QueryOptions} from "../../../core/commons/query.options";
import {BaseRequestOptions, RequestMethod} from "@angular/http";
import {Observable} from "rxjs/Observable";
import {Subject} from "rxjs/Subject";
import {DocumentCategoryView} from "../../domain/documentCategoryView";
import {DocumentService} from "./document.service";
import 'rxjs/add/observable/of';
import {environment} from "../../../../environments/environment";
import {BehaviorSubject} from "rxjs/BehaviorSubject";

@Injectable()
export class DocumentCategoryService extends GenericService<DocumentCategory> {

    categorySelected : Subject<DocumentCategoryView> = new Subject();
    categoryToShow : Subject<DocumentCategoryView> = new Subject();
    parentCategories : BehaviorSubject< DocumentCategoryView[] > = new BehaviorSubject(null);

    //Subject para indicarle al document explorer que ponga el progress indicator
    // arranca en false porque al principio no hay categoria seleccionada
    loadingSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    constructor(public authService: AuthService, private documentService: DocumentService) {
        super(authService);
    }

    protected valueToEntity(value: Object): DocumentCategory {
        return new DocumentCategory(value);
    }

    protected getResourcePath(): string {
        return "/repository/category";
    }

    public getDefaultQueryOptions(): QueryOptions {
        return new QueryOptions();
    }

    public changeCategoryVisibility( categoryId ) : Observable<any>{
        return this.doRequest({
            url: this.baseUrl + this.getResourcePath() + '/change-visibility/' + categoryId,
            method: RequestMethod.Get
        });
    }

    public getParentCategories() {
        let req = {
            url: environment.backendHost + environment.backendPublicApiPath + this.getResourcePath() +"/parents",
            method: RequestMethod.Get
        };
        let options = new BaseRequestOptions();
        options = options.merge(req);
        options.headers.append('Content-Type', 'application/json');

        this.authService.publicRequest( options.url, options)
            .map( res => res.json().map(t => new DocumentCategoryView(t)) )
            .subscribe( categories => this.parentCategories.next(categories) );
    }

    public getCategoriesByParent( d : DocumentCategory ) : Observable<DocumentCategory[]> {
        let req = {
            url: environment.backendHost + environment.backendPublicApiPath + this.getResourcePath() + "/by-parent/"+ d.id,
            method: RequestMethod.Get
        };
        let options = new BaseRequestOptions();
        options = options.merge(req);
        options.headers.append('Content-Type', 'application/json');

        return this.authService.publicRequest( options.url, options)
            .map( res => res.json().map(t => this.valueToEntity(t)) );

        /**
        let req = this.buildRequest(RequestMethod.Get);
        return this.authService.authRequest(this.baseUrl + this.getResourcePath() + "/by-parent/"+ d.id, req)
            .map(res => res.json().map(t => this.valueToEntity(t)) );
         */
    }

    /**
     * Retorna un observable donde se envia la categoria que fue seleccionada con sus sub categorias cargadas
     * @returns {Observable<DocumentCategoryView>}
     */
    public getCategorySelected() : Observable<DocumentCategoryView>{
        return this.categorySelected.asObservable();
    }

    /**
     * Envia una categoria por el observable.
     * @param {DocumentCategoryView} c
     */
    public setCategorySelected( c : DocumentCategoryView) : void{
        if ( ! c.isSubCategoriesLoaded() ) {
            this.getCategoriesByParent(c)
                .do(categories => categories.forEach( cat => cat.parentCategory = c ) )
                .map(c => c.map(category => new DocumentCategoryView(category)))
                .subscribe(categories => {
                    c.loadSubCategories(categories);
                    this.categorySelected.next(c);
                });
        } else {
            this.categorySelected.next(c);
        }
    }

    /**
     * Retorna un observable donde se envia la categoria a mostrar con sus subcategorias y documentos pre cargados.
     * @returns {Observable<DocumentCategoryView>}
     */
    public getCategoryToShow() : Observable<DocumentCategoryView>{
        return this.categoryToShow.asObservable();
    }

    public setCategoryToShow( c : DocumentCategoryView) : void {
        this.loadingSubject.next(true);
        if (!c.isSubCategoriesLoaded()) {
            this.getCategoriesByParent(c)
                .do(categories => categories.forEach( cat => cat.parentCategory = c ) )
                .map(c => c.map(category => new DocumentCategoryView(category)))
                .switchMap(categories => {
                    c.loadSubCategories(categories);
                    if (!c.isDocumentsLoaded()) {
                        return this.documentService.getByCategory(c);
                    } else {
                        return Observable.of([]);
                    }
                })
                .subscribe(documents => {
                    if (!c.isDocumentsLoaded()) {
                        c.loadDocuments(documents);
                    }
                    this.categoryToShow.next(c);
                    this.loadingSubject.next(false);
                });
        } else if ( !c.isDocumentsLoaded() ) {
            this.documentService.getByCategory(c)
                .subscribe(documents => {
                    c.loadDocuments(documents);
                    this.categoryToShow.next(c);
                    this.loadingSubject.next(false);
                });
        }else {
            this.categoryToShow.next(c);
            this.loadingSubject.next(false);
        }

    }

}



// WEBPACK FOOTER //
// ./src/app/fiscalia/service/repository/document-category.service.ts